module.exports = __webpack_public_path__ + "static/img/85.b64534c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/85.png
// module id = 59OM
// module chunks = 1